module.exports = __webpack_public_path__ + "media/sos_received.59ed2abc.wav";